import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { Switch } from '@mui/material';
import SubaccountSearchDropdown from '../../molecules/SubaccountSearchDropdown/view';
import TaxSearchDropdown from '../../molecules/TaxSearchDropdown/view';
import ButtonPrimary from '../../atoms/ButtonPrimary/view';
import ButtonConfirm from '../../atoms/ButtonConfirm/view';
import './style.css';

const emptyForm = {
    name: '',
    is_recurrent: false,
    is_active: true,
    spend_ua_id: null,
    tax_ua_id: null,
    retention_ua_id: null,
};

function SpendTypeForm({
    initialData = {},
    onSubmit,
    loadingId,
    title,
    submitLabel,
    showDelete = false,
    onDelete,
}) {
    const [formData, setFormData] = useState(emptyForm);

    useEffect(() => {
        if (initialData && Object.keys(initialData).length > 0) {
            setFormData({
                name: initialData.name || '',
                is_recurrent: initialData.is_recurrent ?? false,
                is_active: initialData.is_active ?? true,
                spend_ua_id: initialData.spend_ua_id || null,
                tax_ua_id: initialData.tax_ua_id || initialData.tax_id || null,
                retention_ua_id: initialData.retention_ua_id || initialData.retention_id || null,
            });
        }
    }, [initialData]);

    function handleSubmit() {
        if (!formData.name.trim()) return;
        onSubmit({
            name: formData.name,
            is_recurrent: formData.is_recurrent,
            is_active: formData.is_active,
            spend_ua_id: formData.spend_ua_id,
            tax_id: formData.tax_ua_id,
            retention_id: formData.retention_ua_id,
            tax_ua_id: formData.tax_ua_id,
            retention_ua_id: formData.retention_ua_id,
        });
    }

    return (
        <div className="new-spend-type-container">
            <h2 className="new-spend-type-title">{title}</h2>

            <Form
                id="spend-type-form"
                onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}
                style={{ width: '100%', outline: 'none', display: 'block' }}
            >
                {/* ── Sección 1: Información Básica ── */}
                <div className="new-spend-type-section-split">
                    <div className="new-spend-type-sidebar">
                        <h3 className="new-spend-type-section-title">Información Básica</h3>
                        <p className="new-spend-type-section-desc">Define el nombre y las subcuentas contables asociadas al tipo de gasto.</p>
                    </div>
                    <div className="new-spend-type-form-right">
                        <div className="new-spend-type-fields-row">
                            <div className="new-spend-type-field-col" style={{ marginTop: "-4px" }}>
                                <Form.Group className="new-spend-type-group-custom">
                                    <Form.Label>Nombre <span className="req">*</span></Form.Label>
                                    <input
                                        className="new-spend-type-input-premium"
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                                        placeholder="Ej: Arrendamiento, Servicios públicos..."
                                    />
                                </Form.Group>
                            </div>
                            <div className="new-spend-type-field-col">
                                <Form.Group className="new-spend-type-group-custom">
                                    <Form.Label>Subcuenta de Gasto</Form.Label>
                                    <SubaccountSearchDropdown
                                        onSelected={(e) => setFormData(prev => ({ ...prev, spend_ua_id: e.id }))}
                                        selected={formData.spend_ua_id ? { id: formData.spend_ua_id } : null}
                                        data={{ users_accounts_id: formData.spend_ua_id }}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </div>

                <hr className="new-spend-type-separator" />

                {/* ── Sección 2: Configuración Fiscal ── */}
                <div className="new-spend-type-section-split">
                    <div className="new-spend-type-sidebar">
                        <h3 className="new-spend-type-section-title">Configuración Fiscal</h3>
                        <p className="new-spend-type-section-desc">Asigna los impuestos y retenciones que aplican a este tipo de gasto.</p>
                    </div>
                    <div className="new-spend-type-form-right">
                        <div className="new-spend-type-fields-row">
                            <div className="new-spend-type-field-col">
                                <Form.Group className="new-spend-type-group-custom">
                                    <Form.Label>Impuesto</Form.Label>
                                    <TaxSearchDropdown
                                        onSelected={(e) => setFormData(prev => ({ ...prev, tax_ua_id: e.id }))}
                                        selected={formData.tax_ua_id ? { id: formData.tax_ua_id } : null}
                                        data={{ tax_id: formData.tax_ua_id }}
                                    />
                                </Form.Group>
                            </div>
                            <div className="new-spend-type-field-col">
                                <Form.Group className="new-spend-type-group-custom">
                                    <Form.Label>Retención</Form.Label>
                                    <TaxSearchDropdown
                                        onSelected={(e) => setFormData(prev => ({ ...prev, retention_ua_id: e.id }))}
                                        selected={formData.retention_ua_id ? { id: formData.retention_ua_id } : null}
                                        data={{ tax_id: formData.retention_ua_id }}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </div>

                <hr className="new-spend-type-separator" />

                {/* ── Sección 3: Estados ── */}
                <div className="new-spend-type-section-split">
                    <div className="new-spend-type-sidebar">
                        <h3 className="new-spend-type-section-title">Estados</h3>
                        <p className="new-spend-type-section-desc">Controla la recurrencia y el estado de actividad del tipo de gasto.</p>
                    </div>
                    <div className="new-spend-type-form-right">
                        <div className="new-spend-type-fields-row">
                            <div className="new-spend-type-field-col">
                                <Form.Group className="new-spend-type-group-custom new-spend-type-switch-premium">
                                    <Form.Label>Es Recurrente</Form.Label>
                                    <div className="switch-wrapper">
                                        <span className="switch-status-label">{formData.is_recurrent ? 'Sí' : 'No'}</span>
                                        <Switch
                                            checked={formData.is_recurrent}
                                            onChange={(e) => setFormData(prev => ({ ...prev, is_recurrent: e.target.checked }))}
                                            name="is_recurrent"
                                            color="primary"
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="new-spend-type-field-col">
                                <Form.Group className="new-spend-type-group-custom new-spend-type-switch-premium">
                                    <Form.Label>Está Activo</Form.Label>
                                    <div className="switch-wrapper">
                                        <span className="switch-status-label">{formData.is_active ? 'Sí' : 'No'}</span>
                                        <Switch
                                            checked={formData.is_active}
                                            onChange={(e) => setFormData(prev => ({ ...prev, is_active: e.target.checked }))}
                                            name="is_active"
                                            color="primary"
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="new-spend-type-footer-actions">
                    <div className="new-spend-type-footer-left">
                        {showDelete && onDelete && (
                            <ButtonConfirm
                                eventKey="delete-spend-type"
                                onAcept={onDelete}
                                msg="¿Estás seguro de eliminar este tipo de gasto?"
                                title="Eliminar Tipo de Gasto"
                                className="btn-secondary-danger"
                            />
                        )}
                    </div>
                    <div className="new-spend-type-footer-right">
                        <ButtonPrimary
                            onClick={handleSubmit}
                            id={loadingId}
                            title={submitLabel}
                            disabled={!formData.name}
                            showLoading={true}
                            className="variant-green"
                        />
                    </div>
                </div>
            </Form>
        </div>
    );
}

export default SpendTypeForm;
